module.exports = __webpack_public_path__ + "static/media/wN.b243da7d.svg";